import { UNREGISTER_MOBILE_DEVICE_BY_ID } from 'graphql/v2/mutations';
import { mockedUnregisterMobileDeviceDataForMutation } from '../graphqlApollo/mutation/unregisterMobileDevice';

export const mutations = [
  {
    request: {
      query: UNREGISTER_MOBILE_DEVICE_BY_ID,
      variables: { visitorId: 'mockedAutomatedTestsUIVisitorId', mobileDeviceId: 'mockedMobileDevice' }
    },
    newData: () => ({
      data: mockedUnregisterMobileDeviceDataForMutation
    })
  }
];
